import { createAsyncThunk } from '@reduxjs/toolkit';
import { $host } from 'shared/api/base/http';

import { IGetPromoResponse } from '../models/types';

export const getPromo = createAsyncThunk(
  'promo/getPromo',
  async (_, thunkApi) => {
    try {
      const res = await $host.get<IGetPromoResponse>('/promo');
      if (res.status === 200) {
        return res.data;
      } else {
        return thunkApi.rejectWithValue('Ошибка при загрузке изображений');
      }
    } catch {
      return thunkApi.rejectWithValue('Ошибка при загрузке изображений');
    }
  },
);
